// extracted by mini-css-extract-plugin
export default {"root":"Login_root_Qa5IP","paper":"Login_paper_VhjEG"};